export default class UserKeyMap {
  static async create(seedObj) {
    return new UserKeyMap(seedObj);
  }

  constructor(seedObj) {
    this.seedObj = seedObj;
  }

  getShortcutKey(animationId) {
    const shortcutKey = this.seedObj[animationId];
    return shortcutKey;
  }
}
